import { Pipe, PipeTransform } from '@angular/core';
import memo from 'memo-decorator';

const CPF_PATTERN = /^(\d{3})\.?(\d{3})\.?(\d{3})-?(\d{2})$/;
const CNPJ_PATTERN = /^([0-9A-Za-z]{2})\.?([0-9A-Za-z]{3})\.?([0-9A-Za-z]{3})\/?([0-9A-Za-z]{4})-?(\d{2})$/;

@Pipe({
    name: 'cpfCnpj',
    standalone: false
})
export class CpfCnpjPipe implements PipeTransform {
  transform(value: string, blankInvalid = false) {
    return CpfCnpjPipe.transform(value, blankInvalid);
  }

  @memo()
  public static transform(value: string, blankInvalid = false) {
    if (!value) {
      return value;
    }

    const cpfMatch = value.match(CPF_PATTERN);
    if (cpfMatch) {
      return `${cpfMatch[1]}.${cpfMatch[2]}.${cpfMatch[3]}-${cpfMatch[4]}`;
    }

    const cnpjMatch = value.match(CNPJ_PATTERN);
    if (cnpjMatch) {
      return `${cnpjMatch[1]}.${cnpjMatch[2]}.${cnpjMatch[3]}/${cnpjMatch[4]}-${cnpjMatch[5]}`;
    }

    return blankInvalid ? '' : value;
  }
}
